import React from 'react';
import { Price, RegularButton, Typography } from 'fronton-react';
import { getPriceText } from 'utils';
import { btnStyles, CardPriceWrapper, FlexRow, priceRedline, WarningWrapper } from './styled';
import { TypographyProps } from 'fronton-react/typography/types';
import { WarningCircleIcon } from '@fronton/icons-react';
import { FrontonHint } from 'common/components/fronton-hint';
import { useMediaQuery } from 'common/hooks';

type CardPriceProps = {
	price: number;
	unit?: string;
	flexiblePrice?: boolean;
	className?: string;
	mainPriceColor?: TypographyProps['color'];
	oldPrice?: number;
	isAvailable: boolean;
};

export const CardPrice = ({
	price,
	flexiblePrice = true,
	unit = null,
	className = '',
	mainPriceColor,
	oldPrice,
	isAvailable,
}: CardPriceProps) => {
	const isMobile = useMediaQuery('(max-width: 767px)');

	return (
		<CardPriceWrapper className={className}>
			<FlexRow>
				<div data-analyticsName="productPriceLink">
					{flexiblePrice && (
						<Typography variant="s" size="body_accent" color={mainPriceColor}>
							от&nbsp;
						</Typography>
					)}
					<Typography
						variant="l"
						size="body_accent"
						data-qa="card-price"
						color={mainPriceColor}
					>
						{getPriceText(price)}
					</Typography>
					<Typography
						variant="s"
						size="body_accent"
						data-qa="card-unit"
						color={mainPriceColor}
					>
						&nbsp;₽{unit && `/${unit}`}
					</Typography>
				</div>
				{!isAvailable && (
					<FrontonHint
						iconColor="text-minor"
						size="s"
						paragraph="Цена не является офертой"
						placement={isMobile ? 'left' : 'top'}
					/>
				)}

				{!!oldPrice && (
					<Price value={oldPrice} variant="medium" size="s" className={priceRedline} />
				)}
			</FlexRow>

			{isAvailable ? (
				<RegularButton
					variant="primary"
					size="s"
					className={btnStyles}
					data-qa="card-order-btn"
					data-analyticsName="productButtonLink"
				>
					Заказать
				</RegularButton>
			) : (
				<WarningWrapper>
					<WarningCircleIcon type="fill" size="l" color="attention-primary" />
					<Typography as="p" size="body_accent" variant="m" color="attention-primary">
						Услуга недоступна
					</Typography>
				</WarningWrapper>
			)}
		</CardPriceWrapper>
	);
};
